const DEFAULT_VISUAL_MAP_SIZES = {
    large: 700,
    medium: 400,
    small: 200
};

const AVAILABLE_NAMES = [
    "My hat man gandi", "Sneaky Pete", "Doctor Dash", "Lord Linington", "Pixel Pete", "Trail Blazer", "The Phantom Pen", "Houdini",
    "Zigzag Zoe", "Dotty McDash", "Professor Pivot", "Sir Bendsalot", "The Slitherer", "Wall Hugger"];

const SCORE_INCREASE = 5;

export {
    DEFAULT_VISUAL_MAP_SIZES,
    AVAILABLE_NAMES,
    SCORE_INCREASE
}